import { Icon } from '@klickly/front-packages';
import styled from 'styled-components';

export const StyledIconWrapper = styled(Icon)`
    margin-bottom: 60px;
`;
